/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { RuleType, SelectInputOption } from "./types";

export const SELECT_LABEL = "Discover by";
export const FORM_TITLE = "Setup Discovery Rules";
export const READ_ONLY_FORM_TITLE = "Discovery Rules";

export const SELECT_OPTIONS: SelectInputOption[] = [
  { label: "Cloud Account", value: RuleType.CLOUD_ACCOUNT },
  { label: "Resource Type", value: RuleType.RESOURCE_TYPE },
  { label: "Tag", value: RuleType.RESOURCE_TAGS },
  { label: "Resource Group (non-IBM Cloud)", value: RuleType.RESOURCE_GROUP },
  { label: "Resource Group (IBM Cloud)", value: RuleType.IBM_RESOURCE_GROUP },
  { label: "Google Cloud Project ID", value: RuleType.PROJECT_ID },
  { label: "AWS VPC", value: RuleType.AWS_VPC },
  { label: "AWS Security Group", value: RuleType.SECURITY_GROUP_IDS },
];

export const EMPTY_RULE = {
  match: {},
  exclusive: false,
  ibmResourceGroup: false,
};
